export default "__VITE_ASSET__DNoM8TEP__"